module.exports = __webpack_public_path__ + "assets/img/ipad-tablet.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/src/assets/img/ipad-tablet.jpg
// module id = 30
// module chunks = 0